const getReminderTemplates = ({ t, userDetails, adminDetails }) => {
  const userName = userDetails?.lastName || '-'
  const companyName = userDetails?.businessName || '-'
  const adminName = 'MatNEXT' || '-'

  return [
    {
      key: 'template-1',
      title: t('user_templateProvideDataSheetTitle'),
      getSubject: () =>
        t('user_templateProvideDataSheetSubject', { companyName }),
      getBody: () =>
        t('user_templateProvideDataSheetBody', {
          userName,
          adminName,
        }),
    },
    {
      key: 'template-2',
      title: t('user_templateCheckJobTitle'),
      getSubject: ({ jobId }) =>
        t('user_templateCheckJobSubject', {
          jobId: jobId || `[${t('job_Id')}]`,
        }),
      getBody: ({ jobId, batchNumber, invoiceNumber }) => {
        const referenceLines = [
          jobId ? `${t('job_Id')}: ${jobId}` : null,
          batchNumber ? `${t('job_BatchNumber')}: ${batchNumber}` : null,
          invoiceNumber ? `${t('job_InvoiceNumber')}: ${invoiceNumber}` : null,
        ].filter(Boolean)

        return t('user_templateCheckJobBody', {
          userName,
          referenceLines: referenceLines.length
            ? `\n\n${referenceLines.join('\n')}`
            : '',
          adminName,
        })
      },
      fields: [
        {
          key: 'jobId',
          label: t('job_Id'),
          placeholder: t('job_Id'),
        },
        {
          key: 'batchNumber',
          label: t('job_BatchNumber'),
          placeholder: t('job_BatchNumber'),
        },
        {
          key: 'invoiceNumber',
          label: t('job_InvoiceNumber'),
          placeholder: t('job_InvoiceNumber'),
        },
      ],
    },
    {
      key: 'template-3',
      title: t('user_templateProvideReportTitle'),
      getSubject: ({ reportName }) =>
        t('user_templateProvideReportSubject', {
          reportName: reportName || `[${t('rpt_ReportName')}]`,
        }),
      getBody: ({ reportName }) =>
        t('user_templateProvideReportBody', {
          userName,
          reportName: reportName || `[${t('rpt_ReportName')}]`,
          adminName,
        }),
      fields: [
        {
          key: 'reportName',
          label: t('rpt_ReportName'),
          placeholder: t('rpt_ReportName'),
        },
      ],
    },
    {
      key: 'template-4',
      title: t('user_templateUploadDataTitle'),
      getSubject: () => t('user_templateUploadDataSubject'),
      getBody: () =>
        t('user_templateUploadDataBody', {
          userName,
          companyName,
          adminName,
        }),
    },
  ]
}

export { getReminderTemplates }
